import { withLazyFallback } from 'lib/hoc/withLazyFallback';

import PracticeDetails from 'components/practice/Settings/components/PracticeDetails';

const NotFound = withLazyFallback(() => import('components/NotFound'));
const Staff = withLazyFallback(() => import('components/Staff/Staff'));
const Settings = withLazyFallback(() => import('components/practice/Settings/Settings'));

const CalendarSettings = withLazyFallback(
  () => import('components/practice/Settings/components/Calendar/Calendar')
);
const Confirmations = withLazyFallback(
  () => import('components/practice/Settings/components/Confirmations/Confirmations')
);
const EPrescribeSettings = withLazyFallback(
  () => import('components/practice/Settings/components/EPrescribe/EPrescribe')
);
const FormBuilder = withLazyFallback(
  () => import('components/practice/Settings/components/Forms/FormBuilder/FormBuilder')
);
const FormPackets = withLazyFallback(
  () => import('components/practice/Settings/components/Forms/FormPackets/FormPackets')
);
const Forms = withLazyFallback(() => import('components/practice/Settings/components/Forms/Forms'));
const KioskSettings = withLazyFallback(
  () => import('components/practice/Settings/components/Kiosks/KioskSettings')
);
const Packages = withLazyFallback(
  () => import('components/practice/Settings/components/Packages/Packages')
);
const Payers = withLazyFallback(
  () => import('components/practice/Settings/components/Payers/Payers')
);
const Products = withLazyFallback(
  () => import('components/practice/Settings/components/Products/Products')
);
const Resources = withLazyFallback(
  () => import('components/practice/Settings/components/Resources/Resources')
);
const Services = withLazyFallback(
  () => import('components/practice/Settings/components/Services/Service')
);
const Tags = withLazyFallback(() => import('components/practice/Settings/components/Tags/Tags'));
const Roles = withLazyFallback(() => import('components/Roles/Roles'));
const Billing = withLazyFallback(
  () => import('components/practice/Settings/components/Billing/Billing')
);
const AutomationSettings = withLazyFallback(
  () => import('components/practice/Settings/components/AutomationSettings/AutomationSettings')
);
const SelfScheduling = withLazyFallback(
  () => import('components/practice/Settings/components/SelfScheduling/SelfScheduling')
);
const HealthcareProgram = withLazyFallback(
  () => import('components/practice/Settings/components/HealthcareProgram/HealthcareProgram')
);
const CheckInSteps = withLazyFallback(
  () => import('components/practice/Settings/components/CheckInSteps/CheckInSteps')
);

const PatientNotifications = withLazyFallback(
  () => import('components/practice/Settings/components/PatientNotifications/PatientNotifications')
);

const DefaultNotifications = withLazyFallback(
  () =>
    import('components/practice/Settings/components/PatientNotifications/components/PatientNotifications')
);

const ProviderCustomNotifications = withLazyFallback(
  () =>
    import('components/practice/Settings/components/PatientNotifications/components/ProviderCustomNotifications/ProviderCustomNotifications')
);

const PRACTICE_SETTINGS = [
  {
    path: 'settings',
    element: <Settings />,
    handle: { title: 'Settings' },
    children: [
      { path: '', element: <PracticeDetails />, handle: { title: 'Practice Details' } },
      { path: 'services', element: <Services />, handle: { title: 'Services' } },
      { path: 'products', element: <Products />, handle: { title: 'Products' } },
      { path: 'packages', element: <Packages />, handle: { title: 'Packages' } },
      { path: 'calendar', element: <CalendarSettings />, handle: { title: 'Appointments' } },
      { path: 'confirmations', element: <Confirmations />, handle: { title: 'Confirmations' } },
      {
        path: 'forms',
        element: <Forms />,
        handle: { title: 'Forms' },
        children: [
          { path: '', element: <FormBuilder /> },
          { path: 'form-packets', element: <FormPackets />, handle: { title: 'Form Packets' } }
        ]
      },
      { path: 'payers', element: <Payers />, handle: { title: 'Payers' } },
      { path: 'staff', element: <Staff />, handle: { title: 'Staff' } },
      { path: 'roles', element: <Roles />, handle: { title: 'Roles & Permissions' } },
      { path: 'eprescribe', element: <EPrescribeSettings />, handle: { title: 'ePrescribe' } },
      { path: 'billing', element: <Billing />, handle: { title: 'Billing' } },
      { path: 'kiosk', element: <KioskSettings />, handle: { title: 'Kiosk' } },
      {
        path: 'self-scheduling',
        element: <SelfScheduling />,
        handle: { title: 'Self Scheduling' }
      },
      {
        path: 'check-in-steps',
        element: <CheckInSteps />,
        handle: { title: 'Check-in Steps' }
      },
      {
        path: 'patient-notifications',
        element: <PatientNotifications />,
        handle: { title: 'Patient Notifications' },
        children: [
          { path: '', element: <DefaultNotifications /> },
          { path: 'provider', element: <ProviderCustomNotifications /> }
        ]
      },
      { path: 'resources', element: <Resources />, handle: { title: 'Resources' } },
      { path: 'tags', element: <Tags />, handle: { title: 'Tags' } },
      { path: 'automation', element: <AutomationSettings />, handle: { title: 'Automation' } },
      {
        path: 'healthcare-program',
        element: <HealthcareProgram />,
        handle: { title: 'Healthcare Program' }
      },
      { path: '*', element: <NotFound /> }
    ]
  }
];

export default PRACTICE_SETTINGS;
